import {
  AUTH_RECORDING_DATA_FAIL,
  AUTH_RECORDING_DATA_REQUEST,
  AUTH_RECORDING_DATA_RESET,
  AUTH_RECORDING_DATA_SUCCESS,
} from "../constants/recordingAuthConstants";

export const recordingmodul_user_data_reducers = (
  state = { data: {} },
  action
) => {
  switch (action.type) {
    case AUTH_RECORDING_DATA_REQUEST:
      return { loading: true };
    case AUTH_RECORDING_DATA_SUCCESS:
      return { loading: false, data: action.payload, success: true };
    case AUTH_RECORDING_DATA_FAIL:
      return { loading: false, error: action.payload };
    case AUTH_RECORDING_DATA_RESET:
      return {};
    default:
      return state;
  }
};
